import React, { Component } from 'react';
import { Row, Col } from 'antd';

export default class Footer extends Component {

    render() {
        //const { dispatch, isAuthenticated } = this.props

        return (
            <div style={{backgroundColor:'#4C4C4C', color: '#fff'}}>
                <div className="container">
                    <div className="content" style={{paddingTop:'50px', paddingBottom:'50px'}}>
                        <div>
                            <Row>
                                <Col span={18}>
                                    Wasserzweckverband <br/>
                                    Rottenburger Gruppe <br/>
                                </Col>
                                <Col span={6}>
                                    <a href="https://www.rottenburger-gruppe.de/index.php?id=0,9">
                                        Impressum
                                    </a>
                                    <br/>
                                    <a href="https://www.rottenburger-gruppe.de/index.php?id=0,57">
                                        Datenschutz
                                    </a>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Footer.js